// KHIYARSA PATCH: upstream's AppSidebar adds "comments" and "presentation"
// sidebar tabs that are pure Excalidraw+ promos ("14 days of free trial",
// "Sign up now" → plus.excalidraw.com). khiyarsa.com renders the plain
// default sidebar (library etc.) instead. See PATCHES.khiyarsa.md §7.
import { DefaultSidebar } from "@excalidraw/excalidraw";

import "./AppSidebar.scss";

export const AppSidebar = () => {
  return <DefaultSidebar />;
};
